// apiClient.js
import axios from 'axios';
import { REACT_APP_BASE_URL } from '../vars';

const apiClient = axios.create({
  baseURL:REACT_APP_BASE_URL, // Your base URL
  timeout: 20000, // Optional: set request timeout
});

export default apiClient;
